
export default {
    name: 'TitleBox',
    props: {
        backgroundColor: {
            default: 'transparent'
        },
        paddingLeft: {
            default: '20px'
        },
        color: {
            default: '#333'
        },
        leftImg: {
            default: null,
            type: String
        }
    }
}
